import { initRightNowQueueTable } from './js/portal/right_now_queue.js';
import { Datatable } from './Datatable';
import { get_feature_flag_property } from './js/portal/feature_flags.js';
const tableId = 'rightNowPortalQueueItemsTable';

export default function AdminListRightNowPortalQueueItemsPage() {
  const page = (
    <>
      <div id="rightNowPortalQueue" class="row">
        <div class="col-lg-12">
          <div class="card form-card">
            <div class="card-header">Important Information</div>
            <div class="card-body">
              <div class="tab-content">
                <div class="tab">
                  <div class="infobox card card-body">
                    <ul>
                      <li class="portal-danger">
                        Custom role creation/deletion requests are sent to this queue and delivered to RightNow
                        depending on a feature flag.{' '}
                        <b>
                          The flag name is "submit_requests_to_right_now" ( true/false ). When value is 'true' , order
                          processing will bypass queue and call RightNow immediately AND any queued items will start to
                          be processed. When value is 'false', order processing will push the request to the Portal
                          Right Now queue for later processing.
                        </b>
                      </li>
                      <li>
                        Each request are first validated before submitting it to RightNow to ensure that the initial
                        order in SSP succeeded.
                      </li>
                      <li>
                        Creation requests are validated to make sure the groups and permission set and assignments
                        exists in our main IDC table. This ensures that the main order in SSP succeeded.
                      </li>
                      <li>
                        Deletion requests are validated to make sure that the groups, permission set, and assignment
                        have already been removed from our main IDC table. This ensures that the main order in SSP
                        succeeded.
                      </li>
                      <li>
                        If a request fails validation, the item will be removed from the queue.{' '}
                        <b>Because this means that the original SSP order failed before this step.</b>
                      </li>
                    </ul>
                  </div>
                  <div class="portal-danger" id="queuestatus"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Datatable tableId={tableId} />
    </>
  );

  async function onPageReady() {
    initRightNowQueueTable(tableId);
    const featureFlagName = 'submit_requests_to_right_now';
    const shouldSubmitToRightNow = await get_feature_flag_property(`idc.${featureFlagName}`, false, true);

    const statusMessage = shouldSubmitToRightNow
      ? `Queue processing <b>is enabled</b> because ${featureFlagName} flag is <b>true</b>. ( All orders will <b>not</b> push to queue and will call RightNow immediately. Any Items in queue will be processed accordingly )`
      : `Queue processing <b>is disabled</b> because ${featureFlagName} flag is <b>false</b>. ( All requests for RightNow will be pushed to queue for later processing )`;

    document.getElementById('queuestatus').innerHTML =
      `<div class="alert alert-warning" role="alert">${statusMessage}.</div>`;
  }

  return [page, onPageReady];
}
